// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"87c71279","257":"6d807454","345":"b45f1a2c","358":"2a45d19f","538":"48620e85","662":"c98095be","765":"bf00bba5","931":"f3a1ffab","960":"46e22920"}[chunkId] + ".chunk.js";
};